exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "product-slider {\n  display: block;\n  margin-top: .75rem; }\n  @media screen and (max-width: 768px) {\n    product-slider {\n      display: none; } }\n", ""]);

// exports
